import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell } from '@fortawesome/free-solid-svg-icons'
import AppBadge from './app-badge'

type NewReviewBadgeProp = {
  showCount?: boolean,
  count: number
}

function NewReviewBadge({ showCount = true, count }: NewReviewBadgeProp) {
  return (
    <AppBadge variant="primary" className="text-primary ms-2">
      <FontAwesomeIcon icon={faBell} /> {showCount ? count : ''} New
    </AppBadge>
  )
}

export default NewReviewBadge
